import { useEffect, useRef, useState, type PointerEvent } from 'react'

/** Сколько ждать после ухода с кнопки: хватает, чтобы довести мышь до списка. */
const LEAVE_DELAY_MS = 200

const isTouch = (e: PointerEvent) => e.pointerType === 'touch'

/**
 * Наведение с запасом на уход: облачко закрывается не сразу, а через паузу, и
 * заход в само облачко её отменяет — до «Перейти» можно довести мышь.
 *
 * Палец наведения не знает: на касании браузер шлёт «вошли» и сразу «ушли», и
 * облачко гасло через паузу — и от касания кнопки, и от касания самого облачка
 * (жалоба с телефона). Поэтому касания вход/уход игнорируют, а открывает и
 * закрывает облачко `toggle` — касание кнопки; касание мимо — `close`.
 */
export const useGraceHover = () => {
  const [hovered, setHovered] = useState(false)
  const timer = useRef<number | null>(null)
  const clear = () => {
    if (timer.current !== null) window.clearTimeout(timer.current)
    timer.current = null
  }
  useEffect(() => clear, [])
  return {
    hovered,
    enter: (e: PointerEvent) => {
      if (isTouch(e)) return
      clear()
      setHovered(true)
    },
    leave: (e: PointerEvent) => {
      if (isTouch(e)) return
      clear()
      timer.current = window.setTimeout(() => setHovered(false), LEAVE_DELAY_MS)
    },
    toggle: () => {
      clear()
      setHovered((v) => !v)
    },
    close: () => {
      clear()
      setHovered(false)
    },
  }
}
